exports = module.exports = require("../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "a[data-v-95ac72de]{text-decoration:none}a[data-v-95ac72de],a[data-v-95ac72de]:active,a[data-v-95ac72de]:link,a[data-v-95ac72de]:visited{color:#599900}", ""]);

// exports
